import { useEffect, useState } from "react";

const KEY = "rai.dock";

/** Whether the docked watchlist is open, remembered per browser. */
export function useDock(): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(() => {
    try {
      return localStorage.getItem(KEY) !== "closed";
    } catch {
      return true;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(KEY, open ? "open" : "closed");
    } catch {
      // storage blocked: the choice lasts until reload
    }
  }, [open]);
  return [open, setOpen];
}
